import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackShowPhoneInBannerClick } from '../../../analytics/promos';
import { PromosBanner as PromosBannerComponent } from '../../../components/PromosBanner';
import { getGaLabel } from '../../../selectors/analytics';
import { CallButtonContainer } from '../../CallButton';

export const PromosBanner: React.VFC = () => {
  const gaLabel = useSelector(getGaLabel);

  const trackShowPhone = React.useCallback(() => {
    trackShowPhoneInBannerClick(gaLabel);
  }, [gaLabel]);

  return (
    <PromosBannerComponent
      contactsButton={
        <CallButtonContainer
          placeType="promosBanner"
          onShowPhoneClick={trackShowPhone}
          openContactsStyles={{ size: 'XS' as const, theme: 'fill_secondary' }}
          showPhoneStyles={{ size: 'XS' as const, theme: 'fill_secondary' }}
          SinglePhoneComponent={null}
          singlePhoneButtonText="Показать контакты"
        />
      }
    />
  );
};
